import localeFr from './fr'
import localeEn from './en'
import localeEs from './es'
import localeCh from './ch'

const messages = {
  en: localeEn,
  fr: localeFr,
  es: localeEs,
  ch: localeCh
}

export default messages
